<template>
  <div class="nav-menu">
    <nav>
      <router-link to="/dashboard">
        <v-btn class="ma-1" color="error" plain> Home </v-btn>
      </router-link>
      |
      <router-link to="/event/booking">
        <v-btn class="ma-1" color="error" plain> Book Now </v-btn>
      </router-link>
      |
      <router-link to="/about">
        <v-btn class="ma-1" color="error" plain> About </v-btn>
      </router-link>
      |
      <router-link to="/contact-us">
        <v-btn class="ma-1" color="error" plain>
          Contact us
        </v-btn> </router-link
      >|
      <router-link to="/login">
        <v-btn class="ma-1" color="error" plain> Login </v-btn>
      </router-link>
      |
      <v-btn class="ma-1" color="error" plain @click="LogoutUser">
        Logout
      </v-btn>
    </nav>
    <router-view />
  </div>
</template>
<script>
import Common from "@/Common.vue";

export default {
  mixins: [Common],
  data: () => ({
    LoggedFlag: false,
  }),
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");

      this.$router.push('/login');

      var LoggedFlag = false;
      var user = this.$session.get("user");
      user = user == (null || undefined) ? "" : user;
      console.log({ user });
      this.User = user;

      var token = this.$session.get("token");
      token = token == (null || undefined) ? "" : token;
      if (token != "" && user != "") {
        LoggedFlag = true;
      }
      console.log({ LoggedFlag });
      this.LoggedFlag = LoggedFlag;
    },
  },
  beforeMount() {
    // this.refreshPageData();
  },
};
</script>

<style>
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
